import script from "./PartyIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PartyIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__